
import { Popup, Toast } from "vant";
Vue.use(Popup);
import { Component, Vue } from "vue-property-decorator";
import { modifyPrice } from "@/req/user";
@Component({
  components: {},
})
export default class Logout extends Vue {
  public count = 0;
  public showModal = false;
  public confirmFn: any = null;
  public item: any = {};
  public price = "";

  public show(item) {
    this.item = item;
    this.showModal = true;
    return new Promise((resolve) => {
      this.confirmFn = () => {
        resolve(1);
      };
    });
  }
  public async confirm() {
    const obj = {
      commodity_id: this.item.id,
      price: this.price,
    };
    const res = await modifyPrice(obj);
    Toast(res.msg);
    if (res.code == 200) {
      this.showModal = false;
      this.$emit("getList");
    }
  }
}
